import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب أجر ساعة العمل - حاسبة الأجر بالساعة";
const DESCRIPTION =
  "احسب أجر الساعة بناءً على راتبك الشهري وعدد ساعات العمل اليومية. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة كم تكسب في الساعة الواحدة.";
const KEYWORDS = "حاسبة, راتب, أجر, ساعة, عمل, حساب, شهري";
const OG_URL =
  "https://do-calculate.com/calculator/ar/hourly-salary-calculator/";
function HourlySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [dailyWorkHours, setDailyWorkHours] = useState("0");
  const [hourlyRate, setHourlyRate] = useState(null);
  const [error, setError] = useState("");
  const calculateHourlyRate = () => {
    try {
      if (monthlySalary === "0" && dailyWorkHours === "0") {
        setError("الرجاء إدخال راتب وساعات عمل صحيحة لحساب الأجر بالساعة");
        return;
      }
      const workDaysPerMonth = 22;
      const totalWorkHours = dailyWorkHours * workDaysPerMonth;
      const hourlyWage = monthlySalary / totalWorkHours;
      setHourlyRate(hourlyWage);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة سهلة لمعرفة الأجر الذي تكسبه في الساعة
                  بناءً على راتبك الشهري وعدد ساعات العمل اليومية. معرفة أجر
                  الساعة أمر مهم لفهم قيمة وقتك بشكل أفضل، سواء كنت تفكر في
                  التفاوض على راتبك أو تخطط لعمل إضافي. هذه الحاسبة مفيدة
                  للأشخاص الذين يعملون برواتب شهرية ويرغبون في معرفة كيف يمكن أن
                  يتوزع دخلهم على ساعات العمل اليومية.
                </p>
                <p>
                  على سبيل المثال، إذا كنت تتقاضى راتبًا شهريًا قدره 5000 وتعمل
                  8 ساعات في اليوم، يمكنك استخدام هذه الحاسبة لتحديد كم تكسب في
                  الساعة. إن معرفة هذه التفاصيل قد يساعدك في اتخاذ قرارات مالية
                  أكثر حكمة وفي التفاوض على أجور أفضل بناءً على قيمة وقتك
                  الحقيقي.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="monthly-salary">الراتب الشهري:</label>
                    <input
                      id="monthly-salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="daily-work-hours">
                      عدد ساعات العمل اليومية:
                    </label>
                    <input
                      id="daily-work-hours"
                      type="number"
                      value={dailyWorkHours}
                      onChange={(e) => setDailyWorkHours(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateHourlyRate}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  hourlyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>أجر الساعة: {hourlyRate.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب الأجر بالساعة</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد الراتب الشهري
                    </h2>
                  </u>
                  <p>
                    في البداية، تحتاج إلى معرفة الراتب الشهري الذي تتقاضاه. يجب
                    أن يشمل هذا الراتب جميع المزايا والبدلات التي تحصل عليها
                    شهريًا. إدخال الراتب الشهري بدقة هو الخطوة الأولى نحو حساب
                    الأجر بالساعة بشكل صحيح. تذكر أن الراتب الشهري هو الأساس
                    الذي ستبني عليه الحسابات التالية.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: تحديد عدد ساعات العمل اليومية
                    </h2>
                  </u>
                  <p>
                    بعد تحديد الراتب الشهري، يجب عليك إدخال عدد ساعات العمل
                    اليومية. ساعات العمل اليومية تمثل المدة التي تقضيها في العمل
                    كل يوم. يمكن أن تختلف ساعات العمل من يوم لآخر، لكن يجب إدخال
                    العدد المتوسط للساعات التي تعملها يوميًا. هذه المعلومة
                    ضرورية لحساب عدد ساعات العمل الشهري وبالتالي حساب الأجر
                    بالساعة.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب الأجر بالساعة
                    </h2>
                  </u>
                  <p>
                    بعد إدخال الراتب الشهري وعدد ساعات العمل اليومية، يمكنك الآن
                    حساب الأجر بالساعة. للقيام بذلك، قم بحساب عدد ساعات العمل
                    الشهرية من خلال ضرب عدد ساعات العمل اليومية في عدد أيام
                    العمل في الشهر، والذي غالبًا ما يكون 22 يومًا. بعد ذلك، قم
                    بتقسيم الراتب الشهري على عدد ساعات العمل الشهرية للحصول على
                    الأجر بالساعة. هذه العملية الحسابية ستمنحك القيمة الدقيقة
                    للأجر الذي تكسبه في الساعة.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان راتبك الشهري 5000 وعدد ساعات العمل اليومية 8
                    ساعات، فإن الأجر بالساعة سيكون حوالي 28.41.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: استخدام الأجر بالساعة في التخطيط المالي
                    </h2>
                  </u>
                  <p>
                    بعد معرفة الأجر بالساعة، يمكنك استخدام هذه المعلومة في
                    تخطيطك المالي. على سبيل المثال، إذا كنت تفكر في زيادة ساعات
                    عملك أو العمل في وظيفة إضافية، فإن معرفة الأجر بالساعة
                    يساعدك في اتخاذ قرارات مستنيرة. كما يمكن أن يساعدك هذا
                    الحساب في التفاوض على راتب أفضل بناءً على قيمة وقتك.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كنت تخطط للعمل 4 ساعات إضافية يوميًا، يمكنك حساب
                    مقدار الراتب الإضافي الذي ستجنيه بناءً على الأجر بالساعة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HourlySalaryCalculator;
